var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddcampaign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 199.027,
  height: 196.743,
  viewBox: "0 0 199.027 196.743"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -0.747,
  y1: 0.259,
  x2: -1.429,
  y2: 0.745,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffc444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#f36f56"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: -0.886,
  y1: 0.285,
  x2: -1.613,
  y2: 0.925,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -1.251,
  y1: 0.104,
  x2: -2.313,
  y2: 0.905,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.004,
  stopColor: "#e38ddd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9571f6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -0.205,
  y1: -0.044,
  x2: 0.054,
  y2: 1.485,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#aa80f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#6165d7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: -0.296,
  y1: -0.886,
  x2: -0.031,
  y2: 1.918,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: -4.696,
  y1: 0.186,
  x2: -5.807,
  y2: 0.814,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: -5.298,
  y1: 0.492,
  x2: -6.506,
  y2: 0.506,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311944"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#893976"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_602",
  "data-name": "Path 602",
  d: "M2002.019,1583.119a13.325,13.325,0,0,0,8.822-3.767,34.1,34.1,0,0,0,7.751-10.935c4.75-9.906,7.366-23.119,7.366-37.2s-2.616-27.3-7.366-37.2a34.081,34.081,0,0,0-7.751-10.935,12.215,12.215,0,0,0-17.644,0,34.092,34.092,0,0,0-7.751,10.935c-4.75,9.906-7.366,23.119-7.366,37.2s2.616,27.3,7.366,37.2a34.081,34.081,0,0,0,7.751,10.935A13.329,13.329,0,0,0,2002.019,1583.119Z",
  transform: "translate(-1978.08 -1479.31)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: -1.576,
  y1: -0.563,
  x2: -1.099,
  y2: 1.571,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: -3.632,
  y1: -0.557,
  x2: -2.911,
  y2: 1.565,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-10",
  x1: -3.31,
  y1: -0.669,
  x2: -2.3,
  y2: 3.413,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-11",
  x1: -3.145,
  y1: -0.86,
  x2: -2.427,
  y2: 0.944,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff9085"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fb6fbb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-12",
  x1: -4.043,
  y1: -0.701,
  x2: -3.021,
  y2: 3.493,
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-13",
  x1: -18.356,
  y1: 0.372,
  x2: -15,
  y2: 2.287,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-14",
  x1: -2.768,
  y1: -0.443,
  x2: -1.784,
  y2: 2.835,
  xlinkHref: "#linear-gradient-4"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-15",
  x1: 0.575,
  y1: 0.268,
  x2: -1.248,
  y2: 4.008,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-16",
  x1: 0.329,
  y1: 0.659,
  x2: -1.131,
  y2: 4.435,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-17",
  x1: 0.161,
  y1: 1.709,
  x2: 2.26,
  y2: -4.6,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-18",
  x1: -0.551,
  y1: 0.627,
  x2: 0.345,
  y2: 0.627,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#444b8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.996,
  stopColor: "#3e4177"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-19",
  x1: 38.649,
  y1: 0.821,
  x2: 38.5,
  y2: 2.71,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-20",
  x1: 0.904,
  y1: 0.188,
  x2: -0.989,
  y2: 1.691,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-21",
  x1: 1.075,
  y1: 0.291,
  x2: -2.255,
  y2: 2.261,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-22",
  x1: 6.433,
  y1: -15.378,
  x2: 6.482,
  y2: -17.158,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-23",
  x1: -20.729,
  y1: -18.685,
  x2: -21.372,
  y2: -20.26,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#311944"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6b3976"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-24",
  x1: 14.305,
  y1: -27.116,
  x2: 14.271,
  y2: -23.966,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-25",
  x1: 1.133,
  y1: -0.096,
  x2: -3.261,
  y2: 3.653,
  xlinkHref: "#linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-26",
  x1: -3.128,
  y1: -2.038,
  x2: -3.705,
  y2: 0.799,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-27",
  x1: -2.598,
  y1: -1.17,
  x2: -3.176,
  y2: 1.666,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-28",
  x1: -2.362,
  y1: -0.469,
  x2: -2.94,
  y2: 2.368,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-29",
  x1: -2.055,
  y1: 0.1,
  x2: -2.633,
  y2: 2.937,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-30",
  x1: -10.955,
  y1: -0.85,
  x2: -11.545,
  y2: 1.901,
  xlinkHref: "#linear-gradient"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1862",
  "data-name": "Group 1862",
  transform: "translate(-6543.05 -6213.193)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1855",
  "data-name": "Group 1855",
  transform: "translate(6543.05 6288.997)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_595",
  "data-name": "Path 595",
  d: "M658.266,2181.021a11.083,11.083,0,0,1-9.451-6.728l-23.032-55.321a9.67,9.67,0,0,1,5.31-12.76c5.077-2.035,12.991.362,15.143,5.453l23.628,55.922a9.455,9.455,0,0,1-5.582,12.851A23.042,23.042,0,0,1,658.266,2181.021Z",
  transform: "translate(-608.393 -2060.1)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_596",
  "data-name": "Path 596",
  d: "M631.093,2106.211c5.077-2.035,12.991.362,15.143,5.452l21.6,51.132c-3.616-.929-7.9-.845-12-4.448-6.84-6-3.475-13.684-8.9-20.529-2.478-3.13-7.064-6.424-16.4-7.415l-4.759-11.431A9.67,9.67,0,0,1,631.093,2106.211Z",
  transform: "translate(-608.393 -2060.1)",
  opacity: 0.3,
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_597",
  "data-name": "Path 597",
  d: "M394.885,1956.565a4.387,4.387,0,0,1,.589.042l14.237-.156v37.019l-13.748-.189a4.364,4.364,0,0,1-1.078.137c-4.88,0-8.835-8.25-8.835-18.426S390.005,1956.565,394.885,1956.565Z",
  transform: "translate(-386.05 -1921.432)",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_598",
  "data-name": "Path 598",
  d: "M672.052,1517.381a44.376,44.376,0,0,0,0,37.019l105.9,34.05,1.094-103.9Z",
  transform: "translate(-648.391 -1482.363)",
  fill: "url(#linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_599",
  "data-name": "Path 599",
  d: "M749.325,2180.121c-10.069-3.814-13.2-18.423-24.889-18.915-9.173-.385-11.937,8.521-20.925,7.561-9.2-.983-10.745-10.9-21.049-14.4a23.923,23.923,0,0,0-14.342.048,45.2,45.2,0,0,0,3.888,22.2l105.9,34.05-6.265-35.278C761.206,2181.475,754.207,2181.971,749.325,2180.121Z",
  transform: "translate(-648.348 -2104.574)",
  opacity: 0.3,
  fill: "url(#linear-gradient-5)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_180",
  "data-name": "Ellipse 180",
  cx: 25.761,
  cy: 53.727,
  rx: 25.761,
  ry: 53.727,
  transform: "translate(108.94 0)",
  fill: "url(#linear-gradient-6)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_600",
  "data-name": "Path 600",
  d: "M2031.57,1583.119a13.324,13.324,0,0,0,8.822-3.767,34.092,34.092,0,0,0,7.751-10.935c4.75-9.906,7.366-23.119,7.366-37.2s-2.615-27.3-7.366-37.2a34.081,34.081,0,0,0-7.751-10.935,12.215,12.215,0,0,0-17.644,0,34.084,34.084,0,0,0-7.751,10.935,69.057,69.057,0,0,0-4.8,13.983c-1.677,7.125,3.169,14.563,3.169,22.759,0,8.714-4.73,17.556-2.842,25.026a67.759,67.759,0,0,0,4.476,12.638,34.081,34.081,0,0,0,7.751,10.935A13.333,13.333,0,0,0,2031.57,1583.119Z",
  transform: "translate(-1896.869 -1477.487)",
  fill: "url(#linear-gradient-7)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1854",
  "data-name": "Group 1854",
  transform: "translate(110.762 1.823)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1852",
  "data-name": "Group 1852",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_601",
  "data-name": "Path 601",
  d: "M1825.814,1908.453c0,13.612-9.013,24.42-19.975,24.144-10.792-.271-19.419-11.216-19.419-24.449s8.627-24.044,19.419-24.149C1816.8,1883.893,1825.814,1894.841,1825.814,1908.453Z",
  transform: "translate(-1799.754 -1855.844)",
  fill: "url(#linear-gradient-8)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1853",
  "data-name": "Group 1853",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_603",
  "data-name": "Path 603",
  d: "M2071.054,1989.451c0,10.107-4.391,18.133-9.732,17.929-5.258-.2-9.462-8.329-9.462-18.155s4.2-17.854,9.462-17.932C2066.663,1971.214,2071.054,1979.343,2071.054,1989.451Z",
  transform: "translate(-2046.727 -1937.063)",
  opacity: 0.3,
  fill: "url(#linear-gradient-9)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1857",
  "data-name": "Group 1857",
  transform: "translate(6678.856 6322.972)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_605",
  "data-name": "Path 605",
  d: "M2386.483,2240.408l33.229,1.36c2.709.11,4.935,1.981,4.935,4.174h0c0,2.194-2.226,3.834-4.935,3.665l-33.229-2.067a4.064,4.064,0,0,1-3.983-3.771h0A3.588,3.588,0,0,1,2386.483,2240.408Z",
  transform: "translate(-2379.408 -2219.605)",
  opacity: 0.3,
  fill: "url(#linear-gradient-10)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_606",
  "data-name": "Path 606",
  d: "M2360.321,1946.119l38.547-.642c3.231-.053,5.895,2.2,5.895,5.033h0c0,2.834-2.665,5.1-5.895,5.054l-38.547-.5a4.508,4.508,0,0,1-4.491-4.465h0A4.529,4.529,0,0,1,2360.321,1946.119Z",
  transform: "translate(-2354.594 -1945.197)",
  fill: "url(#linear-gradient-11)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_607",
  "data-name": "Path 607",
  d: "M2554.612,2170.334l31.462.96c2.558.078,4.659,1.87,4.659,4h0c0,2.131-2.1,3.75-4.659,3.618l-31.462-1.629a3.849,3.849,0,0,1-3.782-3.63h0A3.483,3.483,0,0,1,2554.612,2170.334Z",
  transform: "translate(-2536.027 -2154.408)",
  fill: "url(#linear-gradient-12)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_608",
  "data-name": "Path 608",
  d: "M3080.8,1946.712a5.8,5.8,0,1,0,5.671-5.256A5.507,5.507,0,0,0,3080.8,1946.712Z",
  transform: "translate(-3029.125 -1941.454)",
  fill: "url(#linear-gradient-13)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1856",
  "data-name": "Group 1856",
  transform: "translate(0 30.03)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_609",
  "data-name": "Path 609",
  d: "M2342.675,2373.106l39.692,3.065c3.333.257,6.083,2.8,6.083,5.682h0c0,2.879-2.75,4.919-6.083,4.563l-39.692-4.24a5.169,5.169,0,0,1-4.615-4.96h0A4.136,4.136,0,0,1,2342.675,2373.106Z",
  transform: "translate(-2338.06 -2373.091)",
  fill: "url(#linear-gradient-14)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_610",
  "data-name": "Path 610",
  d: "M2911.93,2438.136c0,2.16,2.03,4.122,4.568,4.385,2.575.266,4.691-1.313,4.691-3.532s-2.115-4.188-4.691-4.4C2913.96,2434.388,2911.93,2435.976,2911.93,2438.136Z",
  transform: "translate(-2872.004 -2430.297)",
  fill: "#f4f7fa"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1861",
  "data-name": "Group 1861",
  transform: "translate(6556.24 6213.193)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_611",
  "data-name": "Path 611",
  d: "M2152.66,832.791l4.146-2q1.6-.744,3.371-1.465c1.722-.7,3.381-1.293,4.961-1.8,0,0,.087.629-.891,1.176a35.009,35.009,0,0,1-3.237,1.439c-.448.184.428,1.725-.753,2.83a2.339,2.339,0,0,1-3.434-.223l-3.051,1.482Z",
  transform: "translate(-2042.942 -795.24)",
  fill: "url(#linear-gradient-15)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_612",
  "data-name": "Path 612",
  d: "M1296.028,885.58l1.845,3.818a18.356,18.356,0,0,1-4.574,6.053c-5.719,4.894-10.986,2.754-21.263,6.3-4.607,1.591-3.109,1.87-13.676,6.736-8.78,4.044-13.226,6.054-15.983,5.474-8.791-1.85-11.943-18.157-12.468-21.04,9.894-1.61,11.9-2.107,17.68-2.34,13.043-.525,29.576.289,44.255-3.75C1293.614,886.347,1295.061,885.894,1296.028,885.58Z",
  transform: "translate(-1184.391 -849.26)",
  fill: "url(#linear-gradient-16)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_613",
  "data-name": "Path 613",
  d: "M1239.586,2715.649a2.055,2.055,0,0,1-.186.179,3.357,3.357,0,0,0-1.256,2.745c.132,1.774,2.356,4.162,5.126,6.924s2.153-1.188,1.933-1.772-3.636-8.2-3.636-8.2Z",
  transform: "translate(-1192.044 -2551.896)",
  fill: "#26264f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_614",
  "data-name": "Path 614",
  d: "M1275.57,2684.474l-3.107,1.7a.928.928,0,0,1-1.3-1.188c.005-.013.012-.026.018-.039l1.538-3.284Z",
  transform: "translate(-1222.698 -2520.383)",
  fill: "url(#linear-gradient-17)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_615",
  "data-name": "Path 615",
  d: "M833.84,1623.83c5.648.436,25.359,2.655,37.171,18.629a31,31,0,0,1,5.238,10.044c4.2,15.072-7.266,34.228-26.99,49.148l-3.731-4.077a43.393,43.393,0,0,1,4.042-17.008c4.183-8.828,9.344-11.462,9.077-17.471-.307-6.918-7.523-11.822-8.891-12.709-10.156-6.588-19.256-.246-28.2-6.4-4.634-3.191-6.9-8.137-8.107-12.14Z",
  transform: "translate(-796.905 -1536.148)",
  fill: "url(#linear-gradient-18)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_616",
  "data-name": "Path 616",
  d: "M860.725,372.873a5.34,5.34,0,0,0,2.057-1.993,2.912,2.912,0,0,0-1.108-3.762,6.969,6.969,0,0,1-2.49-2.578,3.634,3.634,0,0,0-1.875-1s2.342,4.319,2.624,5.028,1.418.806,0,2.833Z",
  transform: "translate(-837.713 -363.54)",
  fill: "url(#linear-gradient-19)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_617",
  "data-name": "Path 617",
  d: "M789.024,847.319c-3.926.772-8.765.325-15.711.617-11.125.468-19.074-5.985-23.223-8.856-4.531,9.888-4.626,17.217-3.828,22.142.588,3.63,1.482,4.846,1.562,8.908.135,6.838-2.31,7.875-3.459,16.762-.946,7.316.414,8.91-1.722,11.956-1.532,2.185-3.567,3.268-4.777,6.684-.4,1.131-1.4,3.946-.337,4.858,1.7,1.462,5.913-4.336,13.779-5.127,4.2-.422,4.837,1.043,9.186.214,4.747-.905,4.417-2.732,8.866-3.632,4.409-.892,5.747.7,12.5-.107,2.84-.339,4.259-.508,5.145-1.3,2.864-2.547.5-7.614-.018-15.581-.508-7.857,1.442-8.381,2.243-20.081A110.811,110.811,0,0,0,789.024,847.319Z",
  transform: "translate(-725.826 -805.995)",
  fill: "url(#linear-gradient-20)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_618",
  "data-name": "Path 618",
  d: "M600.7,454.621l-2.67-2.991a49.273,49.273,0,0,0-14.667,12.005c-3.886,4.715-7.316,8.877-7.686,14.917-.529,8.658,5.6,15.138,8.454,18.155a35.192,35.192,0,0,0,15.821,9.5c7.185-15.948,6.118-22.176,3.575-24.836-1.416-1.481-3.326-1.893-5.076-4.64-2.436-3.822-2-8.144-1.73-10.885A25.489,25.489,0,0,1,600.7,454.621Z",
  transform: "translate(-575.646 -445.501)",
  fill: "url(#linear-gradient-21)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1859",
  "data-name": "Group 1859",
  transform: "translate(38.6 30.261)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_619",
  "data-name": "Path 619",
  d: "M1138.488,846.9a6.858,6.858,0,0,1-1.106,5.29,7.1,7.1,0,0,1-3.949,2.328c-1.861.5-2.867.094-2.967.414-.221.708,4.343,3.854,9.626,3.657,3.105-.116,6.233-1.378,6.2-2.375-.036-1.119-4.021-.993-5.01-3.311-.632-1.481.239-3.306,1.185-4.727C1141.611,847.178,1139.346,847.9,1138.488,846.9Z",
  transform: "translate(-1130.459 -843.533)",
  fill: "url(#linear-gradient-22)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1858",
  "data-name": "Group 1858",
  transform: "translate(6.918)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_620",
  "data-name": "Path 620",
  d: "M1236.4,802.048a2.279,2.279,0,0,0-.019-2.779,2.818,2.818,0,0,0-2.036-.761c-1.59-.106-3.611.589-4.33,1.977-.426.823.451,2.46.587,2.755.155.334.442.438.706.685.366.342.938.884,1.87,1.792a6.084,6.084,0,0,1,.375-1.018,5.709,5.709,0,0,1,.771-1.209C1235.161,802.518,1235.83,802.757,1236.4,802.048Z",
  transform: "translate(-1229.894 -798.497)",
  fill: "url(#linear-gradient-23)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_621",
  "data-name": "Path 621",
  d: "M1241.307,841.2a3.4,3.4,0,0,0,3.115,1.332c1.865-.194,2.185-4.078,1.007-4.851a2.473,2.473,0,0,0-1.837-.144c-.384.115-.516.268-1.146.445-.582.164-.745.111-.922.255-.221.18-.387.605-.036,1.725a1.03,1.03,0,0,0-1.085-.284.673.673,0,0,0-.253.235C1239.884,840.366,1240.315,840.914,1241.307,841.2Z",
  transform: "translate(-1239.365 -834.72)",
  fill: "url(#linear-gradient-24)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1860",
  "data-name": "Group 1860",
  transform: "translate(0 25.359)",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_622",
  "data-name": "Path 622",
  d: "M625.512,781.928c-4.933-5.4-9.2-3.488-12.926-7.755-5.469-6.257,1.028-13.408-3.1-20.682-5.52-9.721-21.3-4.3-28.437-13.443-1.875-2.4-3.364-6.079-3-12.008a17.43,17.43,0,0,0-2.374,7.692c-.529,8.658,5.6,15.138,8.454,18.155a34.686,34.686,0,0,0,12.98,8.558,19.679,19.679,0,0,1,.532,4.371c.135,6.838-2.31,7.875-3.459,16.762-.946,7.316.414,8.91-1.722,11.956-1.532,2.185-3.567,3.268-4.777,6.684-.4,1.131-1.4,3.946-.337,4.858,1.7,1.462,5.913-4.336,13.779-5.127,4.2-.422,4.837,1.043,9.186.214,4.747-.905,4.417-2.732,8.866-3.632,4.409-.892,5.747.7,12.5-.107,2.84-.339,4.259-.508,5.145-1.3a3.98,3.98,0,0,0,1.267-2.338,9.6,9.6,0,0,1-6.363-2.005C628.528,790.108,629.764,786.579,625.512,781.928Z",
  transform: "translate(-575.637 -728.04)",
  fill: "url(#linear-gradient-25)"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Path_623",
  "data-name": "Path 623",
  d: "M2880.691,1521.171l-.753,4.432,3.31,3.206a.574.574,0,0,1-.326.991l-4.547.56-2.012,3.989a.609.609,0,0,1-1.078-.017l-2.081-4.067-4.607-.736a.6.6,0,0,1-.348-1.012l3.3-3.092-.831-4.491a.587.587,0,0,1,.876-.6l4.135,2.209,4.083-2.01A.616.616,0,0,1,2880.691,1521.171Z",
  transform: "translate(3847.663 4773.416)",
  fill: "url(#linear-gradient-26)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_624",
  "data-name": "Path 624",
  d: "M2783.756,1166.363l-1.068,6.282,4.691,4.545a.813.813,0,0,1-.463,1.4l-6.445.794-2.852,5.654a.864.864,0,0,1-1.529-.025l-2.95-5.766-6.53-1.042a.844.844,0,0,1-.493-1.435l4.684-4.383-1.178-6.365a.832.832,0,0,1,1.242-.856l5.861,3.131,5.788-2.849A.873.873,0,0,1,2783.756,1166.363Z",
  transform: "translate(3942.757 5103.895)",
  fill: "url(#linear-gradient-27)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_625",
  "data-name": "Path 625",
  d: "M2537.43,836.493l-1.311,7.708,5.756,5.576a1,1,0,0,1-.568,1.723l-7.907.974-3.5,6.937a1.061,1.061,0,0,1-1.877-.031l-3.62-7.073-8.013-1.279a1.034,1.034,0,0,1-.6-1.76l5.747-5.377-1.446-7.81a1.021,1.021,0,0,1,1.524-1.05l7.191,3.842,7.1-3.5A1.071,1.071,0,0,1,2537.43,836.493Z",
  transform: "translate(4175.725 5411.089)",
  fill: "url(#linear-gradient-28)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_626",
  "data-name": "Path 626",
  d: "M2220.611,404.6l-1.689,9.934,7.419,7.186a1.286,1.286,0,0,1-.732,2.221l-10.192,1.256-4.51,8.941a1.367,1.367,0,0,1-2.419-.04l-4.667-9.117-10.327-1.648a1.334,1.334,0,0,1-.78-2.269l7.407-6.931-1.864-10.066a1.316,1.316,0,0,1,1.964-1.353l9.269,4.951,9.152-4.507A1.382,1.382,0,0,1,2220.611,404.6Z",
  transform: "translate(4476.404 5813.362)",
  fill: "url(#linear-gradient-29)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_627",
  "data-name": "Path 627",
  d: "M2846.8,1777.775l-1.865,1.726.378,2.577a.324.324,0,0,1-.488.331l-2.229-1.316-2.276,1.094a.345.345,0,0,1-.477-.38l.469-2.539-1.811-1.917a.336.336,0,0,1,.193-.573l2.545-.246,1.175-2.3a.332.332,0,0,1,.6.031l1.091,2.415,2.522.506A.348.348,0,0,1,2846.8,1777.775Z",
  transform: "translate(3875.261 4537.271)",
  fill: "url(#linear-gradient-30)"
}))));
export { SvgAddcampaign as ReactComponent };
export default __webpack_public_path__ + "static/media/addcampaign.0ad5d77a1701ad759c9daac0c5d677b5.svg";